const routes = [
    {
        name: 'linkCobrancaContrato',
        path: '/cobranca_contrato/:hash',
        alias: ['/prop_contrato/:hash', '/cobranca_locacao/:hash'],
        component: () => import('../components/Cobranca'),
        meta: {
            fullScreen: true,
            public: true
        }
    }
]
export default routes
